<template>
    <div id="SuscriptionPickOffer" class="limit-width">

        <div v-if="isLoading" key="SuscriptionPickOfferSpinner" class="app-loading animate__animated animate__fadeIn">
            Cargando...
        </div>

        <div class="animate__animated animate__fadeIn" v-else>
            <ui-tabs :options="offerOptions" v-model="selectedOfferOption" auto-select-first />

            <div class="list" v-if="filtered.length">
                <div class="list-item tappable" v-for="offer in filtered" 
                    :key="'offer-id-' + offer.id"
                    @click="$refs.SuscriptionSelectedModal.openWithOffer(offer)">
                    <div class="title">
                        <b>{{ offer.planName }}</b>
                    </div>
                    <div class="price">
                        <b>{{ offer.precio | currency }}</b>
                    </div>
                </div>
            </div>

            <div class="empty text-center" v-else>
                <h3>Ofertas no disponibles</h3>
            </div>

            <div class="text-center" v-if="displayOfferUpdater">
                <b-button @click="loadUp" variant="outline">Actualizar ofertas</b-button>
            </div>

            <suscription-selected-modal ref="SuscriptionSelectedModal" :msisdn="msisdn" @success="$emit('success')" @fail="$emit('fail')"/>
            
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import UiTabs from '../ui-tabs.vue'
import { getOffers, offerOptions } from './suscriptions'
import SuscriptionSelectedModal from './SuscriptionSelectedModal.vue';
export default {
    name: 'SuscriptionPickOffer',
    components: { SuscriptionSelectedModal, UiTabs },
    props: {
        displayOfferUpdater: {
            type: Boolean,
            default: false
        },
        msisdn: {
            type: String,
            required: true
        },
        offerOptions: {
            type: Array,
            default: () => offerOptions,
        }
    },
    computed: {
        filtered() {
            return _.filter(this.offers, { tipo: this.selectedOfferOption })
        }
    },








    data: () => {
        return {
            isLoading: false,
            selectedOfferOption: null,
            offers: []
        }
    },
    methods: {
        async loadUp() {
            this.isLoading = true;
            this.offers = await getOffers()
            this.isLoading = false;
        }
    },
    beforeMount() {
        this.loadUp()
    }
}
</script>

<style style="scss">
#SuscriptionPickOffer {
    .list {
        color: var(--gray);
        .list-item {
            padding: 0.5em;
        }
    }
}
</style>